import { render } from "./TemplateLanguageEditor.vue?vue&type=template&id=65377ae3&scoped=true"
import script from "./TemplateLanguageEditor.vue?vue&type=script&lang=js"
export * from "./TemplateLanguageEditor.vue?vue&type=script&lang=js"

import "./TemplateLanguageEditor.vue?vue&type=style&index=0&id=65377ae3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65377ae3"]])

export default __exports__